import { render } from "./AgendarCita.vue?vue&type=template&id=6fd005b1&scoped=true"
import script from "./AgendarCita.vue?vue&type=script&lang=js"
export * from "./AgendarCita.vue?vue&type=script&lang=js"

import "./AgendarCita.vue?vue&type=style&index=0&id=6fd005b1&scoped=true&lang=css"

import exportComponent from "/home/raulgarcia/Escritorio/projects/Vue/capwashmx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd005b1"]])

export default __exports__